<template>
  <div id="product-set-page">
    <Header></Header>
    <input
      v-model="barcode"
      type="text"
      class="form-control"
      autofocus
      :placeholder="$t('product_set_page.barcode')"
      aria-describedby="basic-addon1"
      @keyup.enter="searchForProduct"
    />
    <div id="product-set" class="product-set" v-if="product">
      <div class="product-image-wrapper">
        <span class="product-info">{{product}}</span>
        <div
          :style="imageStyle"
          class="product-image"
          v-html="product.product_image"
          @mousemove="highlightPartInTables"
          @mouseleave="removeHighlightsInTables"
        ></div>
      </div>
      <div class="product-set-tables">
        <div class="panel-scrollable">
          <div class="parts-table">
            <ProductFittingsTable
              ref="productFittingsTable"
              :product="product"
            ></ProductFittingsTable>
          </div>
          <div class="parts-table">
            <ProductGlassUnitsTable
              ref="productGlassUnitsTable"
              :product="product"
              @glassUnitViewed="highlightPart"
              @glassUnitExit="removeHighlight"
            ></ProductGlassUnitsTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Product from "@/models/Product.js";
import ProductFittingsTable from "@/components/production-planning/ProductFittingsTable.vue";
import ProductGlassUnitsTable from "@/components/production-planning/ProductGlassUnitsTable.vue";
import Svg from "@/models/Svg.js";
export default {
  name: "product-set-page",
  components: {
    Header,
    ProductGlassUnitsTable,
    ProductFittingsTable
  },
  data() {
    return {
      barcode: this.$route.params.barcode ? this.$route.params.barcode : "",
      product: null,
      originalSvg: null,
      selectedPart: null
    };
  },
  created() {
    if (this.barcode != "") {
      this.searchForProduct();
    }
  },
  computed: {
    imageStyle() {
      const proportion = this.product.width / this.product.height;
      return {
        width: Math.min(40 * proportion, 40) + "%"
      };
    }
  },
  methods: {
    async searchForProduct() {
      this.product = await Product.loadByBarcode(this.barcode);
      if (!this.product) {
        alert(`${this.$t("product_set_page.not_found")} - ${this.barcode}`);
      }
      if (this.product) {
        this.originalSvg = (" " + this.product.product_image).slice(1);
        if (this.$route.params.barcode != this.barcode) {
          this.$router.replace({
            name: "product-set",
            params: { barcode: this.barcode }
          });
        }
      }
      this.barcode = "";
    },
    highlightPart(code) {
      const svg = this.originalSvg;
      this.product.product_image = Svg.highlighByCode(svg, code);
    },
    removeHighlight() {
      this.product.product_image = (" " + this.originalSvg).slice(1);
    },
    highlightPartInTables(event) {
      const part = event.target;
      if (part != this.selectedPart) {
        this.selectedPart = part;
        if (!part.id) return;
        if (this.$refs.productGlassUnitsTable) {
          this.$refs.productGlassUnitsTable.highlightRow(part.id);
        }
      }
    },
    removeHighlightsInTables() {
      if (this.$refs.productGlassUnitsTable) {
        this.$refs.productGlassUnitsTable.removeHighlights();
      }
    }
  }
};
</script>

<style scoped>
#product-set-page {
  position: absolute;
  height: calc(100%);
  width: 100%;
}
.product-set {
  position: relative;
  height: calc(100% - 120px);
}
.product-image {
  position: relative;
  height: 200px;
}

.parts-table {
  position: relative;
  margin-top: 20px;
}
.product-info {
  position: relative;
  font-weight: bold;
  font-size: 20px;
  top: 20px;
  margin-left: 40px;
}
.product-set-tables {
  position: absolute;
  width: calc(50% - 20px);
  height: calc(100% - 50px);
  top: 0px;
  left: 50%;
  overflow-y: auto;
}
</style>